var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.dialogWebcall,
          expression: "dialogWebcall"
        }
      ],
      ref: "draggableContainer",
      attrs: { id: "moduleWebcall" }
    },
    [
      _vm.dialogWebcall
        ? _c(
            "v-flex",
            [
              _c(
                "v-card",
                { staticClass: "elevation-10 blue-grey darken-3" },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "tf_titleWebcall",
                      attrs: { "primary-title": "" },
                      on: { mousedown: _vm.dragMouseDown }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "white--text ma-2",
                          staticStyle: { width: "100%" }
                        },
                        [
                          _c("h3", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.webcallDialogTitle))
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c("div", { staticClass: "white--text" }, [
                      _c(
                        "div",
                        {
                          class: {
                            posAbs: _vm.remoteStream,
                            posRel: !_vm.remoteStream,
                            visioCall: _vm.visioCall,
                            audioCall: !_vm.visioCall
                          },
                          attrs: { id: "tf_localWebcall" }
                        },
                        [
                          _vm.activeConnexionPeer
                            ? _c(
                                "div",
                                {
                                  staticClass: "tf_wave-container",
                                  class: {
                                    active: _vm.jeParle,
                                    inactive: !_vm.jeParle
                                  },
                                  attrs: { id: "tf_wave-local" }
                                },
                                [
                                  _c("div", { staticClass: "wave-bar" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "wave-bar" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "wave-bar" })
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { attrs: { id: "tf_remoteWebcall" } }, [
                        _vm.activeConnexionPeer
                          ? _c(
                              "div",
                              {
                                staticClass: "tf_wave-container",
                                class: {
                                  active: _vm.ilParle,
                                  inactive: !_vm.ilParle
                                },
                                attrs: { id: "tf_wave-remote" }
                              },
                              [
                                _c("div", { staticClass: "wave-bar" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "wave-bar" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "wave-bar" })
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { attrs: { id: "messageWebcall" } }, [
                        _vm._v(_vm._s(_vm.messageWebcall))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-card-actions", [
                    !_vm.connectedConversation &&
                    _vm.sessionWebcall.action != "closeWebCall"
                      ? _c(
                          "div",
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "mx-2",
                                                attrs: {
                                                  fab: "",
                                                  dark: "",
                                                  small: "",
                                                  color: "red"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.rejetWebcall()
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [_vm._v("block")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3119184881
                                )
                              },
                              [
                                _vm._v(" "),
                                _c("span", [_vm._v("Ne pas prendre cet appel")])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.connectedConversation &&
                    _vm.sessionWebcall.action != "closeWebCall"
                      ? _c(
                          "div",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "white--text",
                                attrs: { color: "green", round: "", dark: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.startWebcall()
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { left: "", dark: "" } },
                                  [_vm._v("call")]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("prendre l'appel")) +
                                    "\n            "
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.connectedConversation &&
                    _vm.sessionWebcall.action == "closeWebCall"
                      ? _c(
                          "div",
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "mx-2",
                                                attrs: {
                                                  fab: "",
                                                  dark: "",
                                                  small: "",
                                                  color: "red"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.stopWebcall()
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [_vm._v("close")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1942150554
                                )
                              },
                              [
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(_vm.$t("close")))])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.connectedConversation
                      ? _c(
                          "div",
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "mx-2",
                                                attrs: {
                                                  fab: "",
                                                  dark: "",
                                                  small: "",
                                                  color: "red"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.stopWebcall()
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [_vm._v("call_end")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3961660414
                                )
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Raccrocher")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "mx-2",
                                                class: _vm.muteMicStatus
                                                  ? "red"
                                                  : "green",
                                                attrs: {
                                                  fab: "",
                                                  dark: "",
                                                  small: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleMic(
                                                      _vm.muteMicStatus
                                                    )
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _vm.muteMicStatus
                                                ? _c(
                                                    "v-icon",
                                                    { attrs: { dark: "" } },
                                                    [_vm._v("mic_off")]
                                                  )
                                                : _c(
                                                    "v-icon",
                                                    { attrs: { dark: "" } },
                                                    [_vm._v("mic")]
                                                  )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1792738991
                                )
                              },
                              [
                                _vm._v(" "),
                                _vm.muteMicStatus
                                  ? _c("span", [_vm._v("Activer le micro")])
                                  : _c("span", [_vm._v("Couper le micro")])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.connectedConversation && _vm.visioCall
                      ? _c(
                          "div",
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "mx-2",
                                                class: _vm.muteCamStatus
                                                  ? "red"
                                                  : "green",
                                                attrs: {
                                                  fab: "",
                                                  dark: "",
                                                  small: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleCam(
                                                      _vm.muteCamStatus
                                                    )
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _vm.muteCamStatus
                                                ? _c(
                                                    "v-icon",
                                                    { attrs: { dark: "" } },
                                                    [_vm._v("videocam_off")]
                                                  )
                                                : _c(
                                                    "v-icon",
                                                    { attrs: { dark: "" } },
                                                    [_vm._v("videocam")]
                                                  )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3024331567
                                )
                              },
                              [
                                _vm._v(" "),
                                _vm.muteCamStatus
                                  ? _c("span", [_vm._v("Activer la caméra")])
                                  : _c("span", [_vm._v("Couper la caméra")])
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.isMobileIOS
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    staticClass: "mx-2",
                                                    class: _vm.blurStatus
                                                      ? "green"
                                                      : "grey",
                                                    attrs: {
                                                      fab: "",
                                                      dark: "",
                                                      small: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggleBlur(
                                                          _vm.blurStatus
                                                        )
                                                      }
                                                    }
                                                  },
                                                  on
                                                ),
                                                [
                                                  _vm.blurStatus
                                                    ? _c(
                                                        "v-icon",
                                                        { attrs: { dark: "" } },
                                                        [_vm._v("blur_on")]
                                                      )
                                                    : _c(
                                                        "v-icon",
                                                        { attrs: { dark: "" } },
                                                        [_vm._v("blur_off")]
                                                      )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1146679394
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _vm.blurStatus
                                      ? _c("span", [
                                          _vm._v("Annuler le floutage du fond")
                                        ])
                                      : _c("span", [_vm._v("Flouter le fond")])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.cameras.length > 1
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    staticClass: "mx-2",
                                                    class: _vm.camChange
                                                      ? "green"
                                                      : "green",
                                                    attrs: {
                                                      fab: "",
                                                      dark: "",
                                                      small: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.changeCamera(
                                                          _vm.camChange
                                                        )
                                                      }
                                                    }
                                                  },
                                                  on
                                                ),
                                                [
                                                  _vm.camChange
                                                    ? _c(
                                                        "v-icon",
                                                        { attrs: { dark: "" } },
                                                        [_vm._v("camera_front")]
                                                      )
                                                    : _c(
                                                        "v-icon",
                                                        { attrs: { dark: "" } },
                                                        [_vm._v("camera_rear")]
                                                      )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3802258283
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _vm.camChange
                                      ? _c("span", [_vm._v("Caméra avant")])
                                      : _c("span", [_vm._v("Caméra arrière")])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c840d84e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c840d84e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzModuleWebcallAPZ.vue
// module id = null
// module chunks = 